import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VMenu,
    {
      ref: "menu",
      attrs: {
        "close-on-content-click": false,
        transition: "scale-transition",
        "offset-y": "",
        "min-width": "auto",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                VTextField,
                _vm._g(
                  _vm._b(
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.dateString,
                        readonly: "",
                        outlined: "",
                      },
                    },
                    "v-text-field",
                    { ...attrs, ..._vm.$attrs },
                    false
                  ),
                  { ...on, ..._vm.$listeners }
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _vm._v(" "),
      _c(
        VDatePicker,
        _vm._b(
          {
            attrs: {
              "no-title": "",
              scrollable: "",
              min: _vm.min,
              max: _vm.max,
            },
            on: {
              input: function ($event) {
                _vm.menu = false
              },
            },
            model: {
              value: _vm.dValue,
              callback: function ($$v) {
                _vm.dValue = $$v
              },
              expression: "dValue",
            },
          },
          "v-date-picker",
          { ..._vm.$attrs },
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }